/*
 * Copyright (C) 2020 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { styled } from '@material-ui/core';

import { Breakpoints } from 'utils/enums';

const FooterDesktop = styled('nav')(({ theme }) => ({
  display: 'none',

  [theme.breakpoints.up(Breakpoints.Md)]: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: theme.spacing(1.75),
    marginTop: theme.spacing(1),
    maxWidth: theme.typography.pxToRem(480),
    width: '100%',
  },
}));

const FooterDesktopText = styled('div')(({ theme }) => ({
  '& a': {
    color: theme.palette.secondary.dark,
    textDecoration: 'none',
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  '&:hover': {
    '& a': {
      opacity: 0.6,
    },
  },
  '&:last-child': {
    margin: 0,
  },
  margin: theme.spacing(0, 0, 2, 0),
}));

export { FooterDesktop, FooterDesktopText };
